// The `controller` subpath, not the root barrel: the root re-exports `FormViewerStatic` and the
// whole `@wix/form-fields` barrel (thousands of modules, stylesheets), which the OOI worker build
// cannot compile. This subpath is the one Forms ships for controllers.
import { defaultLocaleDatasetLoader, loadTranslations } from '@wix/form-viewer/controller';
import { fetchForms } from './forms-api';
import { EMPTY_PRELOADED_FORMS, } from './types';
/**
 * Resolves the forms a document embeds, plus the Wix Forms translations for the locale. In an OOI
 * controller this runs on the server, which is what puts the rendered form in the server HTML.
 */
export const preloadForms = async ({ httpClient, formIds, language, }) => {
    if (formIds.length === 0) {
        return EMPTY_PRELOADED_FORMS;
    }
    const fetched = await fetchForms(httpClient, formIds);
    const list = Object.values(fetched);
    const [translations, localeDataset] = await Promise.all([
        loadTranslations(language),
        defaultLocaleDatasetLoader(list, language)(),
    ]);
    const forms = {};
    Object.entries(fetched).forEach(([id, form]) => {
        forms[id] = { form };
    });
    return { forms, translations, localeDataset };
};
/** `preloadForms` bound to one http client, for handing a renderer a function instead of a client. */
export const createLoadForms = (httpClient) => (formIds, language) => preloadForms({ httpClient, formIds, language });
//# sourceMappingURL=preload.js.map